import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import typography from 'styles/components/typography.module.scss'
import { Spacer } from 'components/Utility'
import { FlexRow } from 'components/Flex'
import { DisabledTag, GreenTag, GreyTag } from 'components/Tag'
import { parseStoreStatus } from '../../../lib/helper'

type Props = {
  id: string
  isPublished: boolean
  name: string
}

const TagCard: FC<Props> = React.memo((props) => {
  const { id, isPublished, name } = props

  const dispatch = useDispatch()

  return (
    <div className={styles.row__inner_clickable} onClick={() => dispatch(push(`/admin/master/tags/${id}`))}>
      <h4 className={typography.headline_small}>{name}</h4>
      <Spacer size={8} />
      <FlexRow justifyContent={'start'}>
        {isPublished ? (
          <GreenTag shape={'ellipse'} size={'large'} tagName={'公開中'} />
        ) : (
          <DisabledTag shape={'ellipse'} size={'large'} tagName={'非公開'} />
        )}
      </FlexRow>
    </div>
  )
})

export default TagCard
